import React from 'react'
import { Route } from 'react-router'
import getPath from '../shared/utils/getPath'
import HelpContainer from './containers/HelpContainer'

const helpRoutes = (
  <Route
    component={HelpContainer}
    key="help-routes"
    path={getPath('backend', '/help')}
  />
)

export default helpRoutes



// WEBPACK FOOTER //
// ./src/help/routes.js